<template>
    <ul class="pagination" v-if="totalPages > 1">
        <li :class="{ disabled: !previousPage }">
            <router-link :to="getPageRoute(previousPage)" v-if="previousPage">
                &laquo;
            </router-link>
            <span v-else>&laquo;</span>
        </li>

        <li v-for="page in pageLinks" :class="{ active: page === currentPage }">
            <span v-if="typeof page == 'string'">{{ page }}</span>
            <router-link :to="getPageRoute(page)" v-else>{{ page}}</router-link>
        </li>

        <li :class="{ disabled: !nextPage }">
            <router-link :to="getPageRoute(nextPage)" v-if="nextPage">
                &raquo;
            </router-link>
            <span v-else>&raquo;</span>
        </li>
    </ul>
</template>

<script>
import PaginatorMixins from './PaginatorMixins';

export default {
    mixins: [PaginatorMixins],
    computed: {
        currentPage() {
            return parseInt(this.$route.query.page) || 1;
        },
    },
    methods: {
        getPageRoute(page) {
            return {
                path: this.$route.path,
                params: { ...this.$route.params },
                query: { ...this.$route.query, page },
            };
        },
    },
}
</script>
